import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { CustomBtn } from '../../../../components/button/button';
import { PostRequest } from '../../../../redux/actions/PostRequest';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { ShowLoader } from '../../../../redux/actions/loader';

const Annoucement = (props) => {
    const dispatch = useDispatch();
    const url = useSelector((state) => state.Api);
    const userToken = JSON.parse(sessionStorage.getItem('User_Data'))?.token || undefined;

    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [selectedTerm, setSelectedTerm] = useState('');
    const [exam, setExam] = useState([])
    const [selectedExam, setSelectedExam] = useState()
    const [showIfFinalTerm, setShowIfFinalTerm] = useState(false)
    
    // Generate the next 15 years
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 10 }, (_, i) => currentYear + i);

    const fee = () => {
        const confirmed = window.confirm("غواړئ فیس اعلان کړئ؟");

        if (confirmed) {
            dispatch(PostRequest(url.annnounceFees, JSON.parse(sessionStorage.getItem("User_Data")).token));
        } else {
            //console.log("Fee announcement cancelled by user.");
        }
    };

    const salary = () => {
        const confirmed = window.confirm("غواړئ معاش اعلان کړئ؟");

        if (confirmed) {
            dispatch(PostRequest(url.annnounceSalary, JSON.parse(sessionStorage.getItem("User_Data")).token));
        } else {
            //console.log("Salary announcement cancelled by user.");
        }
    };

    const transport = () => {
        const confirmed = window.confirm("غواړئ معاش اعلان کړئ؟");

        if (confirmed) {
            //console.log('confirmed')
            dispatch(PostRequest(url.transportFeesAnnounce, JSON.parse(sessionStorage.getItem("User_Data")).token));
        } else {
            //console.log("Salary announcement cancelled by user.");
        }
    }

    const exams = async() => {
              dispatch(ShowLoader('1'))
        
        try {  
            const response = await axios.post(url.examCreation, 
                {Year:selectedYear, Term: showIfFinalTerm? 1 :0, TermYear : showIfFinalTerm? selectedYear+' Final' :selectedYear+' Mid', prvTerm : showIfFinalTerm? selectedExam : 0}, 
                {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userToken}`,
                },
            }); 
    
            if (response.status === 200 && response.data) {
              dispatch(ShowLoader('0'))
              callExams()

                //console.log('Response Data (Valid):', response.data);
            } else {
                //console.error('Invalid response data:', response.data);
            }
            dispatch({
                type: 'SHOW_MODAL',
                response: 'Exam Created successfully',
                severity: "Success"
              });
        } catch (error) {
            dispatch(ShowLoader('0'))

            //console.error('Error in API call:', error);
        } 
    };

    const callExams = async () => {
        try {  
            const response = await axios.get(url.resultYear, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userToken}`,
                },
            }); 
    
            if (response.status === 200 && response.data) {
                //console.log('Response Data (Valid):', response.data);
                setExam(response.data.result);  // Update the state with the result
            } else {
                //console.error('Invalid response data:', response.data);
            }
        } catch (error) {
            //console.error('Error in API call:', error);
        }
    };
    
    useEffect(() => {
        callExams();  // Call the function once on component mount
    }, []);
     
    const handleTerm = (e) => {
        setSelectedTerm(e.target.value) 
        if(e.target.value == 1)
        setShowIfFinalTerm(true)
        else 
        setShowIfFinalTerm(false)

    }
    return (
        <Grid container>
            <Grid item lg={12}>
                <h3>Please remember to keep announcing School Fees, Transport Fees and Salary regularly every month on selected date only once.</h3>
                <h2>مهرباني وکړئ په یاد ولرئ چې هره میاشت په ټاکل شوې نیټه یوازې یو ځل دشوونځۍ فیسونه ، دټرانسپورټ فیسونه او معاشونه په منظم ډول اعلان کړئ</h2>
                <br/>
            </Grid>
            <Grid item lg={4}>
                <CustomBtn data="Announcement Of Fee  د فیس اعلان" click={fee} />
            </Grid>
            <Grid item lg={4}></Grid>
            <Grid item lg={4}>
                <CustomBtn data="Announcement Of Salary  د معاش اعلان" click={salary} />
            </Grid>
            
            <br/>
            <br/>
            <br/>
            <br/>
            <Grid item lg={4}></Grid>

            <Grid item lg={4}>
                <CustomBtn data="Announcement of Transport Fees  دټرانسپورټ فیس اعلان " click={transport} />
            </Grid>
            <Grid item lg={4}></Grid>
            <br/>
            <br/>
            <br/>
            <Grid item lg={10}>
                <h2>
                    دامتحان کال وټاکئ 
                </h2>
            </Grid>
            <Grid item lg={10}>
                <FormControl fullWidth>
                    <InputLabel>Select Year</InputLabel>
                    <Select
                        value={selectedYear}
                        onChange={(e) => setSelectedYear(e.target.value)}
                        label="Select Year"
                    >
                        {years.map(year => (
                            <MenuItem key={year} value={year}>
                                {year}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <br/>
                <br/>
                <FormControl fullWidth>
                    <InputLabel>Select Term</InputLabel>
                    <Select
                        value={selectedTerm}
                        onChange={(e) => handleTerm(e)}
                        label="Select Term"
                    >
                        <MenuItem value="0">Mid Term</MenuItem>
                        <MenuItem value="1">Final Term</MenuItem>
                    </Select>
                </FormControl>
                <br/>
                <br/>
                {showIfFinalTerm? 
                <Select mt={2} fullWidth
                    value={selectedExam}
                    onChange={(e) => setSelectedExam(e.target.value)}
                    label="Select Year"
                    >
                    {exam.map(year => (
                        <MenuItem key={year.Srn} value={year.Srn}>
                            {year.TermYear}
                        </MenuItem>
                    ))}
                </Select>
                : null}
                
                <br/>
                <br/>   
                <CustomBtn data="Announcement Of Examination  د امتحان اعلان" click={exams} />
            </Grid>
        </Grid>
    );
};

Annoucement.propTypes = {};

export default Annoucement;
